import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import blue from '@material-ui/core/colors/blue';
import EditIcon from '@material-ui/icons/Edit';

import { genQuery } from '../../../common/helpers';

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  textField: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
}));

const ItemsQuery = (props) => {
  const classes = useStyles();
  const { onClose } = props;
  const { data, error, loading } = useQuery(gql`${props.query}`);
  if (loading) return (
    <ListItem button key='loading' value='loading'>
      Cargando...
    </ListItem>
  )
  if (error) return (
    <ListItem button key='loading' value='loading'>
      {`Error: ${error}`}
    </ListItem>
  );

  function handleListItemClick(value) {
    onClose(value);
  }
  return (
    <>
      {data[props.alias].map((item) => (
        <ListItem button onClick={() => handleListItemClick(item[props.campos[0]])} key={item[props.campos[0]]}>
          <ListItemAvatar>
            <Avatar className={classes.avatar}>
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={item[props.campos[1]]} />
        </ListItem>
      ))}
    </>
  )
}
ItemsQuery.propTypes = {
  onClose: PropTypes.func.isRequired,
  /*query: PropTypes.string.isRequired,
  alias: PropTypes.string.isRequired,*/
  /*open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,*/
};
const ItemsData = (props) => {
  const classes = useStyles();
  const { onClose } = props;
  function handleListItemClick(value) {
    onClose(value);
  }

  return (
    <>
      {
        props.data.map((item) => (
          <ListItem button onClick={() => handleListItemClick(item.codigo)} key={item.codigo}>
            <ListItemAvatar>
              <Avatar className={classes.avatar}>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={item.valor} />
          </ListItem>
        ))
      }
    </>
  )
}

const DialogDB = (props) => {
  const { onClose, selectedValue, open } = props;

  function handleClose() {
    onClose(selectedValue);
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="dialogDB" open={open}>
      <DialogTitle id="dialogDBTitulo">Selecciona</DialogTitle>
      <List>
        {
          (props.query && props.query !== '' && !props.data) ?
            <ItemsQuery
              onClose={onClose}
              query={genQuery(props.alias, props.campos, props.atributos)}
              alias={props.alias}
              campos={props.campos}
            /> :
            <ItemsData
              onClose={onClose}
              data={props.data}
            />
        }
      </List>
    </Dialog>
  );
};

DialogDB.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function SearchDB(props) {

  //Inicializar Estilos del componente
  const classes = useStyles();

  //Estados
  const [values] = React.useState(props);
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(props.selectedValue);


  const handleClickOpen = () => {
    setOpen(true);
  }

  const handleClose = value => {
    setOpen(false);
    setSelectedValue(value);
    props.setSelectedValue(value);
  };


  return (
    <div>
      <TextField
        id={values.id}
        label={values.label}
        className={classes.textField}
        value={props.selectedValue ? props.selectedValue : ""}
        margin="normal"
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={handleClickOpen}
              >
                <EditIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <DialogDB selectedValue={selectedValue} open={open} onClose={handleClose} alias={props.alias} campos={props.campos} atributos={props.atributos} data={props.data} />
    </div>
  );
};

/*export default SearchDB;*/